import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MedicoService } from 'src/app/services/medico.service';
import { Medico } from 'src/app/models/medico.interface';
import { AuthService } from 'src/app/services/auth.service';
import { RedimirMedico } from 'src/app/models/redimir.interface';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';
import { Paginar } from 'src/app/models/http-paginacion.interface';
@Component({
  selector: 'app-medico-canjes',
  templateUrl: './medico-canjes.component.html',
  styleUrls: ['./medico-canjes.component.scss']
})
export class MedicoCanjesComponent {
  medico!: Medico;
  canjes!: RedimirMedico[];
  estatus: string[] = [...DESCRIPCION_STATUS_CANJE];
  currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItems: number = 10;

  constructor(
    private medicoService: MedicoService,
    private authService: AuthService,
    private router: Router) {

    if (this.authService.isLoggedIn) {
      const id: number | undefined = this.authService.getUsuario?.medico?.id;
      if (id) this.obtenerInformacion(id);
    }

  }
  get totalPaginas(): number {
    return Math.ceil(this.canjes.length / this.currentPage.rows);
  }
  get paginacionCanjesMedicos(): RedimirMedico[] {
    const startIndex = (this.currentPage.page) * this.currentPage.rows;

    return this.canjes !== undefined ? this.canjes.slice(startIndex, startIndex + this.currentPage.rows) : [];
  }
  obtenerInformacion(id: number): void {
    this.medicoService.getMedicos(id).subscribe({
      next: (resp) => {
        this.medico = resp.datos;
        this.canjes = resp.datos.redimir;
        this.totalItems = resp.datos.redimir.length;
        //console.log(resp)
      },
      error: (err) => console.log(err)
    });
  }

  getDescripcion(id: number): string {
    return this.estatus[id];
  }
  onPageChange(event: any) {
    this.currentPage = <Paginar>event;
  }
  nuevoCanje(): void {
    this.router.navigate(['/medico/solicitud/canje']);
  }
}
